<div class="color-container">
  <div class="top-section">
    <div class="e-container">
      <div class="c-container">
        <span
          class="c-first-text sf-pro-display"
          [innerHTML]="'HOME_HEADER_SUB_TITLE' | transloco"
        ></span>

        <div class="title" [class.hidden]="isHidden" *ngIf="currentTitle">
          <span *ngIf="currentTitle.black.length > 0" class="heading-black">
            {{ currentTitle.black | transloco }}</span
          >
          <span class="heading-color">{{
            currentTitle.color | transloco
          }}</span>
          <span *ngIf="currentTitle.black2.length > 0" class="heading-black">
            {{ currentTitle.black2 | transloco }}</span
          >
        </div>

        <span class="c-sub-title sf-pro">
          {{ "HOME_HEADER_DESCR_UNDER_TITLE" | transloco }}
        </span>

        <div class="join-button">
          <button
            class="join sf-pro-display"
            [class.hidden]="!showJoinUventex"
            (click)="openDialog()"
          >
            <span>{{ "HOME_HEADER_JOIN_BUTTON" | transloco }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="c-sections">
      <div class="c-section-detail">
        <span class="c-section-detail-title sf-pro-display">
          {{ "EVENT_MANAGEMENT_CAP" | transloco }}
        </span>
        <span
          class="c-section-detail-descr sf-pro-display"
          [innerHTML]="'HOME_HEADER_SECTION_ONE_DESCR' | transloco"
        >
        </span>
      </div>

      <div class="c-section-detail">
        <span class="c-section-detail-title sf-pro-display">
          {{ "HOME_HEADER_STUDIO_MANAGEMENT" | transloco }}
        </span>
        <span
          class="c-section-detail-descr sf-pro-display"
          [innerHTML]="'HOME_HEADER_SECTION_TWO_DESCR' | transloco"
        >
        </span>
      </div>

      <div class="c-section-detail">
        <span class="c-section-detail-title sf-pro-display">
          {{ "HOME_HEADER_REGISTRATION" | transloco }}
        </span>

        <span
          class="c-section-detail-descr sf-pro-display"
          [innerHTML]="'HOME_HEADER_SECTION_THREE_DESCR' | transloco"
        >
        </span>
      </div>

      <div class="c-section-detail">
        <span class="c-section-detail-title sf-pro-display">
          {{ "HOME_HEADER_MEMBERSHIPS" | transloco }}
        </span>

        <span
          class="c-section-detail-descr sf-pro-display"
          [innerHTML]="'HOME_HEADER_SECTION_FOUR_DESCR' | transloco"
        >
        </span>
      </div>
    </div>

    <!-- <div class="description-row">
                        <p class="description">
                              {{ "HOME_HEADER_DESCRIPTION" | transloco }}
                        </p>
                  </div> -->
  </div>
</div>
